import { Currency, ETHER, Token } from 'mtv-mswap-sdk'
import { BinanceIcon } from 'mtv-mswap-uikitty'
import React, { useMemo } from 'react'
import styled from 'styled-components'
import useHttpLocations from '../../hooks/useHttpLocations'
import { WrappedTokenInfo } from '../../state/lists/hooks'
import getTokenLogoURL from '../../utils/getTokenLogoURL'
import Logo from './Logo'

const StyledLogo = styled(Logo)<{ size: string }>`
  width: ${({ size }) => size};
  height: ${({ size }) => size};
`

export default function CurrencyLogo({
  currency,
  size = '24px',
  style,
}: {
  currency?: Currency
  size?: string
  style?: React.CSSProperties
}) {
  const uriLocations = useHttpLocations(currency instanceof WrappedTokenInfo ? currency.logoURI : undefined)

  const srcs: string[] = useMemo(() => {
    if (currency === ETHER) return []

    if (currency instanceof Token) {
      if (currency instanceof WrappedTokenInfo) {
        return [...uriLocations, getTokenLogoURL(currency.name)]
      }
      return [getTokenLogoURL(currency.name)]
    }
    return []
  }, [currency, uriLocations])

  const path = `/images/tokens/${currency.symbol.toUpperCase()}.png`

  return <img src={path} width="20px" height="20px" alt="" />  
}
